import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemSecondaryAction } from '@material-ui/core';
import React from 'react';
const styles = {
  listItem: {
    listStyleType: 'none'
  },
  avatar: {
    width: 60,
    height: 60
  }
};
const ADD_AVATAR = 'Add avatar';
const CHANGE_AVATAR = 'Change avatar';
const REMOVE_AVATAR = 'Remove avatar';

/**
 * Represents a default component for Avatar control.
 */
export const DefaultAvatarTemplate = props => {
  const {
    actionName,
    readOnly,
    repositoryUrl,
    url
  } = props;
  return /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    style: styles.listItem
  }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
    src: repositoryUrl && url ? `${repositoryUrl}${url}` : undefined,
    style: styles.avatar
  })), actionName && actionName !== 'browse' && !readOnly ? /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
    title: CHANGE_AVATAR,
    onClick: props.add
  }, props.renderIcon('refresh')), /*#__PURE__*/React.createElement(IconButton, {
    title: REMOVE_AVATAR,
    onClick: () => {
      var _props$remove;

      return (_props$remove = props.remove) === null || _props$remove === void 0 ? void 0 : _props$remove.call(props);
    }
  }, props.renderIcon('remove_circle'))) : /*#__PURE__*/React.createElement(IconButton, {
    title: ADD_AVATAR,
    onClick: props.add
  }, props.renderIcon('add'))) : null);
};
//# sourceMappingURL=default-avatar-template.js.map